import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

/**
 * Custom UrlSerializer that replaces the `//` outlet separator with `~`
 * in serialized URLs. This prevents server-side URL normalization (Vite/connect)
 * from collapsing `//` to `/`, which breaks Angular's auxiliary route parsing
 * on page reload.
 */
export class CustomUrlSerializer extends DefaultUrlSerializer implements UrlSerializer {
  override serialize(tree: UrlTree): string {
    return super.serialize(tree).replace(/\/\//g, '~');
  }

  override parse(url: string): UrlTree {
    return super.parse(url.replace(/~/g, '//'));
  }
}
